// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2lsfm","title":"Header_title__FLz0S","left":"Header_left__2uOb7","clinicName":"Header_clinicName__1MtXl"};